import { PropsWithChildren } from 'react'
//import FooterComponent from './Footer'
import HeaderComponent from './Header'
import Support from '../Support';
import dynamic from 'next/dynamic';
import PopupNotification from '../PopupNotification';


const DynamicFooter = dynamic(() => import('./Footer'));
const DynamicLoadingComponent = dynamic(() => import('../Loading'));

type TLayoutProps = PropsWithChildren & {
    props?: any,
    className?: string,
    isDetailPage?: boolean,
    isLoading?: boolean,
    componentToolkit?: any,
    loadingEnd?: boolean
}

const LayoutComponent = ({ children, className, isLoading = true, props, componentToolkit=null, loadingEnd}: TLayoutProps) => {
    loadingEnd = (loadingEnd ? loadingEnd : isLoading)
    return (
        <main {...props} className={className}>
             <HeaderComponent/>
            <div className='body mt-[50px] md:mt-[64px]'>
                {children}
            </div>
            {!loadingEnd && 
                <div className="wrap-toolkit">
                    <Support isDetail={true}/>
                    {componentToolkit}
                </div>
            }
            {!loadingEnd && <DynamicFooter />}
            {isLoading == true && <DynamicLoadingComponent loading={isLoading} />}
            {!loadingEnd && <PopupNotification />}
        </main>
    )
}
 
export default LayoutComponent